import RenderIf from '../render-if/Renderif';
import { useMedicalSummary } from '../../hooks/useMedicalSummary';
import { useAddCaseFormContext } from '../../contexts/AddCaseFormContext';
import Tabs from './tabs';
import MedicalRecordDetails from './MedicalRecordDetails';
import XModal from '../common/XModal';

const recordRowClasses = 'row bg-surface-light';

const sectionColumnClasses = 'w-full max-w-full shrink-0 px-3';

const sectionTitleClasses = 'text-content font-bold text-base leading-6 mb-2 mt-4';

const recordCardClasses = 'mt-4 text-base overflow-y-auto text-content border border-border rounded bg-surface-alt';

const billsColumnClasses = 'w-full max-w-full shrink-0 px-3 mt-6! mb-10!';

const billsTitleClasses = 'text-content font-bold text-base leading-6 mb-2';

const billTableClasses = `
    w-full mb-4 text-content align-top border-border-light text-base
    [&>:not(caption)>*>*]:p-2
    [&>:not(caption)>*>*]:bg-white
    [&>:not(caption)>*>*]:border-b
    [&>:not(caption)>*>*]:shadow-[inset_0_0_0_9999px_transparent]
    [&>thead]:align-bottom
    [&_thead]:bg-table-header
    [&_thead]:border-t-table-header
    [&_thead_tr]:text-subtle
    [&_td]:text-sm
    [&_th]:text-sm
    [&_td]:whitespace-normal
    [&_th]:whitespace-normal
    [&_td]:break-words
    [&_th]:break-words
    [&_td]:text-left
    [&_th]:text-left
    [&_tr]:whitespace-normal
    [&_tr]:break-words
`;
const tableHeaderRowClasses = 'bg-table-header [&_th]:h-10 [&_th]:pt-2.5 [&_th]:pl-2.5 [&_th]:text-base [&_th]:font-normal [&_th]:leading-6';
const headerCellClasses = 'text-content';
const amountHeaderClasses = 'text-right text-content';
const amountCellClasses = 'text-right';
const billRowClasses = 'bg-white';

const MedicalViewSummaryModal = () => {
    const { isOpenProcessedMedicalRecordsModal, closeMedicalSummaryModal } = useAddCaseFormContext();
    const {
        plaintiffs,
        selectedTiffIndex,
        setSelectedTiffIndex,
        filterClientsMedicalData,
        groupedBillData,
        handleDownload
    } = useMedicalSummary();

    return (
        <XModal
            isOpen={isOpenProcessedMedicalRecordsModal}
            title="Medical Summary"
            onClose={closeMedicalSummaryModal}
            onSubmit={handleDownload}
            submitText="Download"
            size="lg"
        >
            <Tabs
                tabList={plaintiffs.map(plaintiff => ({ ...plaintiff, name: plaintiff.personalInfo?.clientName }))}
                selectedTabIndex={selectedTiffIndex}
                onTabChange={setSelectedTiffIndex}
                tabType="client"
                isModalTab={true}
            />

            <div className={recordRowClasses}>
                <RenderIf shouldRender={filterClientsMedicalData?.preMedicalRecords?.length}>
                    <div className={sectionColumnClasses}>
                        <h6 className={sectionTitleClasses}>Pre-Accident Medical Records</h6>
                        {filterClientsMedicalData?.preMedicalRecords?.map((data, index) => (
                            <div key={index} className={recordCardClasses}>
                                <MedicalRecordDetails data={data} />
                            </div>
                        ))}
                    </div>
                </RenderIf>

                <RenderIf shouldRender={filterClientsMedicalData?.medicalRecords?.length}>
                    <div className={sectionColumnClasses}>
                        <h6 className={sectionTitleClasses}>Post-Accident Medical Records</h6>
                        {filterClientsMedicalData?.medicalRecords?.map((data, index) => (
                            <div key={index} className={recordCardClasses}>
                                <MedicalRecordDetails data={data} />
                            </div>
                        ))}
                    </div>
                </RenderIf>

                <RenderIf shouldRender={groupedBillData?.length}>
                    <div className={billsColumnClasses}>
                        <h6 className={billsTitleClasses}>Medical Bill Records</h6>
                        <div>
                            <table className={billTableClasses}>
                                <thead>
                                    <tr className={tableHeaderRowClasses}>
                                        <th className={headerCellClasses}>S.No</th>
                                        <th className={headerCellClasses}>Medical Provider Name</th>
                                        <th className={amountHeaderClasses}>
                                            Total Bill Amount
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {groupedBillData?.map((data, index) => (
                                        <tr key={index} className={billRowClasses}>
                                            <td>{index + 1}</td>
                                            <td>{data.medicalProviderName}</td>
                                            <td className={amountCellClasses}>{data.totalBillAmount}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </RenderIf>
            </div>
        </XModal>
    );
};

export default MedicalViewSummaryModal;
